/* ===================================
    Form Reset jQuery Plugin
=================================== */
;(function ( $, window, document, undefined ) {
    var pluginName = "resetForm",
        defaults = {
            clearDefaults: false,
            callback : function(){}
        };

    function resetForm( element, options ) {
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init(this.$element, this.options);
    }

    resetForm.prototype = {
        init: function (trigger, options) {
            var target = trigger.attr('data-reset-form'),
                formFields = $(target).find(':input'),
                ckEditors = $(target).find('.ck-instance');

            //first clear fields
            if(this.settings.clearDefaults) {
                UI.clearFields(formFields);
            } else {
                $(target)[0].reset();
            }

            // clear any CK Editors too
            if ( ckEditors.length ) {
                ckEditors.each( function () {
                    CKEDITOR.instances[ckEditors.attr('data-ckId')].setData('');
                });
            }

            // trigger change events
            formFields.trigger('change');

            //update chosen select fields to reflect the reset
            $('[data-state]').attr('data-state', '');
            $('.chosen-select-country').trigger('change');

            $('.chosen-select, .chosen-select-full, .chosen-select-auto, .chosen-select-state').trigger('chosen:updated');

            //clear any errors that appeared
            UI.clearErrors(formFields);

            //callback
            if( $.isFunction(this.settings.callback) ){
                this.settings.callback.call( this );
            }
        }
    };

    $.fn.resetForm = function ( options ) {
        this.each(function() {
            // removed the check for existing instances since this should be able to run multiple times
            new resetForm( this, options );
        });

        return this;
    };

})( jQuery, window, document );

(function($) {
    var $d = $(document);

    // we aren't accepting Employer input in p2p
    $("#employer-information").addClass('hide-content');

    Interface.prototype.init = function(){
        UI.supportSVG();
        UI.focusOnLoad();
        UI.autoAdvance();
        UI.enablePrintPage();
        UI.renderCustomSelect();
        UI.interfaceReady();
        UI.vendor.twitter();
        UI.toggleInlineLabel('.label-is-placeholder .form-field', 'body');

        // analytics/tracking
        if ( QGIV.Form.id ) {
            var tracking = '/for/tracking.php?';
            tracking += 'url='+encodeURIComponent(window.location.href)+'&';
            tracking += 'entity='+encodeURIComponent(QGIV.Form.id)+'&';
            tracking += 'useragent='+encodeURIComponent(window.navigator.userAgent)+'&';
            tracking += 'referrer='+encodeURIComponent($('#referrer').val())+'&';
            tracking += 'platform='+encodeURIComponent(window.navigator.platform);
            $.get(tracking);
        }

        // Skip Navigation - change focus to content
        $(".skip-nav").on('click', function(e) {
            var skipTo="#"+this.href.split('#')[1];
            $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
                $(this).removeAttr('tabindex');
            }).focus();
        });

        // Easy Way to Slide Toggle Content
        $('.page-container').on('click', '.slide-toggle-content', function(e){
            UI.slideToggleContent(this);

            if ( ! $(this).is(":checkbox, :radio") ){
                e.preventDefault();
            }
        });

        // If user customized toolbar font size in cms we need to adjust .page-container padding-top
        // to avoid unwanted gap when small font or toolbar spillover into navigation when big font.
        // 16px is default font-size when a user HAS NOT edited their toolbar font-size. Assuming
        // majority of orgs aren't editing their toolbars, we only want this to run in the case that
        // they do.
        if($('.global-bar').css('font-size') !== '16px') {
            // Below is the latest recommended syntax for jQuery's .ready() method. See https://api.jquery.com/ready/
            $(function() {
                var adjustedHeight = $('.global-bar').css('height');
                $('.page-container').css('padding-top', adjustedHeight);
                window.scrollTo(0, 0);
            });
        }

        // Slide Toggle content and change the link text (i.e. Show/Hide)
        $('.text-toggle-link').on('click', function(e) {
            var target = $(this).attr('href'),
                defaultTxt = $(this).attr('data-default-text'),
                activeTxt = $(this).attr('data-active-text'),
                txt = $(target).is(':visible') ? defaultTxt : activeTxt;

            e.preventDefault();
            UI.slideToggleContent($(this));
            $(this).text(txt);
        });

        // Easy Way to Show / Hide Content
        $('.event-container').on('click', '.show-toggle-content', function(e){
            UI.toggleContent(this);

            if ( ! $(this).is(":checkbox, :radio") ){
                e.preventDefault();
            }
        });

        // Easy Way to Show / Hide Content from Select Option
        $('.page-container, .cms-toolbar-container').on('change', '.show-toggle-select-content', function(){
            var selected = $(this).find('option:selected');

            selected.siblings().each(function(){
                $($(this).attr('data-content-toggle')).addClass('hide-content');
            });

            UI.toggleContent(selected);
        });

        // Select All Checkbox
        if ( $('.select-deselect-all').length ) {

            $('.select-deselect-all').on('change', function() {
                var target = $(this).attr('data-target');

                if ( $(this).hasClass('is-selected') ) {
                    $('[name="' + target + '"]').prop('checked', false).removeClass('auto-selected');
                } else {
                    $('[name="' + target + '"]').prop('checked', true).addClass('auto-selected');
                }

                $(this).toggleClass('is-selected');
            });

            $(document).on('click', '.auto-selected', function() {
                var parent = $(this).closest('.data-table');

                parent.find('.select-deselect-all').prop('checked', false).removeClass('is-selected');
            });

        }

        // Checkbox Toggle
        $('.checkbox-toggle').on('change', function() {
            var target = $(this).attr('data-content-toggle'),
                inverted = $(this).hasClass('inverted');

            // Not using UI.toggleContent since we also need to check on change when forms are reset
            if ( ($(this).is(':checked') && inverted) || ( ! $(this).is(':checked') && ! inverted) ){
                $(target).addClass('hide-content');
            } else if ( $(this).is(':checked') || inverted ) {
                $(target).removeClass('hide-content');
            } else {
                $(target).addClass('hide-content');
            }

            // If there were errors, clear them
            if ($(target).find('input').hasClass('has-error')){
                UI.clearErrors($(target).find('input'));
            }
        });

        // Disable Links
        $('.page-container').on('click', '.ui-disabled', function (e) {
            e.preventDefault();
            return false;
        });

        if ( $('.refresh-page').length ) {
            $('.refresh-page').on('click', function( e ) {
                e.preventDefault();
                window.location.reload(true);
            });
        }

        // Controls Display of Mobile Menu
        $('.mobile-menu-button').on('click', function(){
            UI.toggleStatus('show-menu');
        });

        // UI Popup Container with Click Handler
        $('.event-container').on('click', '.popup-click .ui-popup-trigger', function () {
            var target = $(this).closest('.ui-popup-container');

            target.toggleClass('active');

            if ( target.hasClass('active') ) {
                target.trigger('popupShown');
            } else {
                target.trigger('popupHidden');
            }

            UI.bindClickOut('.ui-popup-container.active.popup-click', function(){
                if($('.ui-popup-container.popup-click').hasClass('active')){
                    $('.ui-popup-container.active').removeClass('active').trigger('popupHidden');
                }
            });
        });

        $('.label-is-placeholder .form-field').trigger('blur');

        // initialize phone formatting
        UI.formatPhone();

        // File uploads
        var updateFileVal = function(target, filename) {
            var parent = target.closest('.field-container');
            if(target.val() != ''){
                parent.addClass('has-value').find('.ui-file-name').text(filename);
            } else {
                parent.removeClass('has-value').find('.ui-file-name').text('');
            }
        };

        $('.ui-file-upload input[type="file"]').on('change', function() {
            var filename = $(this).val().split('\\').pop();

            updateFileVal($(this), filename);
        });

        $('.ui-file-name').on('click', function(e) {
            var inputField = $(this).closest('.field-container').find('.ui-file-upload input[type="file"]');
            e.preventDefault();
            // Reset the form field by wrapping it in a form tag, resetting the form and then unwrapping
            $(inputField).wrap('<form>').closest('form').get(0).reset();
            $(inputField).unwrap();
            $(inputField).trigger('change');
        });

        // Management lists
        $('.ui-management-list .ui-management-toggle').on('click', function(e){
            var isSelectAll = $(e.target).hasClass('item-select-all');
            if (!isSelectAll){
                $(this).closest('.ui-management-item').toggleClass('active');
            }
        });

        $('.ui-management-list .item-select-all').on('click', function(e){
            $(this).closest('.ui-management-item').find('.item-content input:checkbox:not(:checked)').prop('checked', 'checked');
        });

        // Edit / Add Content
        var $triggers = $('.ui-management-list .editable-list .edit-link, .ui-management-list .cancel-link, .ui-management-list .add-to-list .add-link');
        $triggers.on('click', function(e){
            var parent = $(this).closest('.ui-management-item');
            e.preventDefault();

            if ($(this).is('.edit-link, .add-link')){
                if ( parent.hasClass('active') ) {
                    return false;
                } else {
                    $('.ui-management-item').removeClass('active').find('.ui-management-title, .action:first').removeClass('appearance-disabled');
                    parent.addClass('active');
                    parent.find('.ui-management-title, .action:first').addClass('appearance-disabled');
                }
            }

            if ( $(this).is('.cancel-link') ) {
                parent.removeClass('active');
                parent.find('.ui-management-title, .action:first').removeClass('appearance-disabled');
            }
            // After the active class has been updated, scroll to the right area
            if (parent.hasClass('active')){
                UI.scrollToElement( $(this), 300, undefined, 60 );
            } else {
                UI.scrollToElement( $('.page-container') );
            }
        });

        // Content Tabs
        $('.js-tabs').each(function(){
            var tab = $('.js-tab:first a', this);
            if ( $('.js-tab', this).hasClass('active-tab') ){
                tab = $('.active-tab a', this);
            }
            UI.toggleTabbedContent(tab);
        });

        $(document).on('click', '.js-tab-link', function(e) {
            UI.toggleTabbedContent($(this));
            e.preventDefault();
        });

        // bind toggling of payment option tab
        $('.payment-option-tab').on('click', function(e){
            $('.js-payment-type-stored, .js-account-payment-method').prop('checked', false);
            UI.toggleTabbedContent($(this));
        });

        $('.js-payment-type-option').on('change', function(){
            // If the payment type is paypal, you should not be able to store
            // the payment method for future use. Hide the option and uncheck
            // the checkbox (we have to check the checkbox, then trigger a
            // "click" to trigger the slide animation event)
            if ( $(this).val() == 'paypal' ) {
                $('.js-store-new-payment-container')
                    .addClass('hide-content')
                    .find(".js-store-new-payment")
                    .prop("checked", true)
                    .trigger("click");
            }

            if ( $(this).val() == 'applepay') {
                $('.js-submit-donation-button').addClass('hide-content');
                $('.js-submit-registration-button').addClass('hide-content');
                $('.js-apple-pay-button').removeClass('hide-content');

                // hide the option and uncheck the checkbox (we have to use "click" for the slide animation event binding)
                $('.js-store-new-payment-container').addClass('hide-content');
                if ( $('.js-store-new-payment-container').find('.js-store-new-payment').is(':checked') ) {
                    $('.js-store-new-payment-container').find('.js-store-new-payment').trigger('click');
                }
            } else {
                $('.js-submit-donation-button').removeClass('hide-content');
                $('.js-submit-registration-button').removeClass('hide-content');
                $('.js-apple-pay-button').addClass('hide-content');
            }

            // PayPal and Apple Pay payment types cannot be saved. Show store
            // payment container for all other payment types
            if ($(this).val() !== "paypal" && $(this).val() !== "applepay") {
                $(".js-store-new-payment-container").removeClass(
                    "hide-content",
                );

                if (
                    !$("#store-new-payment").prop("checked") &&
                    $(".new-method-nickname").hasClass("hide-content")
                ) {
                    $(".new-method-nickname").css("display", "none");
                }
                
            }
        });

        // manually setting the payment type to stored if a stored payment is selected
        $('.js-account-payment-method').on('change', function(){
            // unchecking other payment type options
            // can we get away with a selector this global?
            $('[name="payment_type"]').prop('checked', false);

            // set the selected payment type to stored
            $(this).closest('.js-account-payment-methods').find('.js-payment-type-stored').prop('checked', true);
        });

        // Responsive tables
        if ( $(".data-table-scroll").length ){
        $(".data-table-scroll").wrap( '<div class="table-container"></div>' );
        }

        if($('.ui-options-dropdown').length > 0){
            // Option dropdown
            UI.bindOptionsToggle('.ui-options-toggle, .ui-options-trigger');

            $('.ui-options-toggle, .ui-options-trigger').on('click', function () {
                UI.bindClickOut('.ui-options-dropdown', function(selector){
                    if ( $(selector).hasClass('active') ){
                        $(selector).removeClass('active');
                        if ($('.registration-summary-pane').length > 0 && $('.registration-summary-pane').hasClass('lower-z')) {
                            $('.registration-summary-pane').removeClass('lower-z');
                        };
                    }
                });
            });

            $('.ui-options-content .field-input').on('change', function() {
                var parent = $(this).closest('.ui-options-dropdown').attr('data-parent-container') || '.event-body',
                    table = $(parent).find($('.data-table'));
                // Hide all of the rows initially
                table.find('.data-row').hide();

                if ( $(parent).find('.ui-options-content input:checked').length ) {
                    // Loop through the checked ones and select rows with the matching 'data-type' attr
                    $(parent).find('.ui-options-content input:checked').each(function () {
                        var typeValue = $(".ui-options-content label[for='" + this.id + "']").text().toLowerCase();

                        // If there are existing search results...
                        if(table.hasClass('has-search-results')){
                            // Only reveal items that are already visible
                            table.find('.data-row.is-search-result[data-type~="' + typeValue + '"]').show();
                        } else {
                            // If not, reveal any matching items
                            table.find('.data-row[data-type~="' + typeValue + '"]').show();
                        }
                    });
                } else {
                    if(table.hasClass('has-search-results')){
                        table.find('.data-row.is-search-result').show();
                    } else {
                        // If not, reveal any matching items
                        table.find('.data-row').show();
                    }
                }
            });

            var repositionOptions = function() {
                $('.ui-options-dropdown').each(function() {
                    var parent = $(this).attr('data-parent-container') || '.event-body';
                    if ($(parent + ' .ui-options-mobile-container').is(':visible')){
                        $(parent + ' .ui-options-dropdown').appendTo(parent + ' .ui-options-mobile-container');
                    } else {
                        $(parent + ' .ui-options-dropdown').appendTo(parent + ' .ui-options-default-container');
                    }
                });
            }

            var showAllOptions = function() {
                $('.ui-options-dropdown input[type="checkbox"]').prop('checked', false).trigger('change');
            }

            // Converts data-type values to lower case to match the option label values
            var normalizeDataType = function() {
                $('[data-type]').each( function () {
                    var value = $(this).attr('data-type').toLowerCase();

                    $(this).attr('data-type', value);
                });
            }

            normalizeDataType();
            repositionOptions();
            // Move the options dropdown on mobile views
            $(window).resize(function() {
                repositionOptions();
            });
        }

        if ( $('.ui-options-external-trigger').length ) {
            $('.ui-options-external-trigger').on('click', function (e) {
                $(this).toggleClass('active ui-primary-color');
            });

            $('.ui-options-show-all').on('click', function (e) {
                e.preventDefault();
                showAllOptions();
                $('.ui-options-external-trigger').removeClass('ui-primary-color');

                if ( $('.clear-search-button').length ) {
                    $('.clear-search-button').trigger('click');
                }
            });
        }

        // For some of the ui-option-list items that have nested form elements, we can't have them wrapped
        // in labels because it overrides focus on FF and IE
        if($('span.option-label').length) {
            $('span.option-label').on('click', function() {
                var input = $(this).find('input');

                if(!input.prop('checked')) {
                    input.prop('checked', true).trigger('change');
                }
            });
        }

        // Initialize clipboard copy for button text
        if ($('.js-copy-text').length) {
            UI.clipboard();
        }

        // Initialize clipboard copy for tooltips
        if ($('.js-copy-text-tooltip').length) {
            UI.clipboardTooltip();
        }

        // Global Search Button
        $('[class^=global-search-container] .search-button').on('click', function( e ) {
            var $parent = $(this).closest('[class^=global-search-container]');

            $parent.find('.search-field').trigger('keyup');
        });

        if($('#content-search-field').length > 0) {
            $('#content-search-field').fsearch({
                length : 0,
                list : '.search-list .data-row',
                target : 'data-alias',
                keyupCallback : function() {
                    if ($('#content-search-field').val().length < 3) {
                        resetTable();
                    }
                },
                searchCallback : function(count) {
                    resetTable();
                    // If there are search results and the search field is filled out, add some states
                    if (count >= 1 && $('.search-field-container').hasClass('has-value')) {
                        $('.search-list').closest('.data-table').addClass('has-search-results');
                        $('.data-row:visible').addClass('is-search-result');
                    }

                    if ( $('#content-search-field').val().length ) {
                        $('.clear-search-button').removeClass('hide-content');
                    }
                }
            });

            $('.clear-search-button').on('click', function() {
                $('#content-search-field').val('').keyup();
            });

            // Reset search results class names
            var resetTable = function() {
                $('.clear-search-button').addClass('hide-content');
                $('.search-list').closest('.data-table').removeClass('has-search-results');
                $('.data-row.is-search-result').removeClass('is-search-result');
                //if($('.ui-options-dropdown').length > 0){
                //    $('.ui-options-content input[type="checkbox"]').prop('checked', true);
                //}
            }
        }

        if ( $('.ui-iconpicker').length ) {
            var $parent = $('.ui-iconpicker'),
                isIconFont = $parent.find('.ui-list').is('.ui-icon'),
                hasSearch = $parent.find('.search-field-container');

            if ( isIconFont ) {
                $(document).on('click', '.ui-iconpicker .ui-list a', function (e) {
                    var $parent = $(this).closest('.ui-iconpicker'),
                        icon = $(this).text();

                    e.preventDefault();
                    $parent.find('.icon-selection').text(icon);
                    $parent.find('.ui-popup-trigger').trigger('click');
                });
            }

            if ( hasSearch ) {
                $('.ui-popup-trigger').on('click', function () {
                    var $parent = $(this).closest('.ui-iconpicker');

                    $parent.find('.search-field').focus();
                });
            }

        }

        if($('.populate-field').length > 0) {
            // Link to populate a field
            $('.populate-field').on('click', function(e) {
                var target = $(this).attr('href') || $(this).attr('data-populate-target'),
                    value = $(this).attr('data-populate-value');

                    e.preventDefault();
                    $(target).val(value);
            });
        }

        if ( $('.image-gallery').length ) {
            $('.image-gallery').each(function (i) {
                $(this).gallery({
                    type : 'slideshow'
                });
            });
        }

        // Prevents Body from scrolling when inside over
        $('.scrollable').on('DOMMouseScroll mousewheel', function(ev) {
            var $this = $(this),
                scrollTop = this.scrollTop,
                scrollHeight = this.scrollHeight,
                height = $this.height(),
                delta = (ev.type == 'DOMMouseScroll' ?
                    ev.originalEvent.detail * -40 :
                    ev.originalEvent.wheelDelta),
                up = delta > 0;

            var prevent = function() {
                ev.stopPropagation();
                ev.preventDefault();
                ev.returnValue = false;
                return false;
            }

            // Only use this if the container has a max-height that's exceeded
            if ( ( $this.outerHeight() == parseInt($this.css('max-height') ) ) || $this.hasClass('force-scrollable') ) {
                if ( ! up && -delta > scrollHeight - height - scrollTop) {
                    // Scrolling down, but this will take us past the bottom.
                    $this.scrollTop(scrollHeight);
                    return prevent();
                } else if (up && delta > scrollTop) {
                    // Scrolling up, but this will take us past the top.
                    $this.scrollTop(0);
                    return prevent();
                }
            }
        });

        // Open social sharing button in popup window instead of tab
        if($('.social-sharing-popup').length > 0) {
            UI.openWindow('.social-sharing-popup', 'Share');
        }

        if ( $('.useradmin-thermometer').length > 0 ) {
            $('.useradmin-thermometer .form-actions .alt-action').on('click', function() {
                UI.clearFields( $('.useradmin-thermometer #update-goal-amount') );
                UI.clearErrors( $('.useradmin-thermometer #update-goal-amount') );
                $('.thermometer-form .ui-message.error').remove();
            });
        }

        // sorting for team widget
        if ( $('.team-list-widget').length > 0 ){
            var $teamList = $('.js-team-list:first .js-user').clone();

            $('.js-sort-team-members').on('change', function(){
                var users = $teamList.get(),
                    _type = $(this).val(),
                    _sort = $(this).find(':selected').attr('data-sort'),
                    _limit = $(this).attr('data-limit') || 'all',
                    container = $(this).attr('data-container'),
                    $userList = $(container).find('.js-widget-team-list .user-list');

                // make sure we are sorting more than one user
                if ( users.length > 1 ){
                    // sort the items
                    users.sort(function(a,b){
                        // grab the values of relevant data attributes
                        var itemA = $(a).attr('data-' + _type),
                            itemB = $(b).attr('data-' + _type);

                        // if we're comparing amounts, convert to number
                        if ( _type == 'amount' ){
                            itemA = parseInt(itemA, 10);
                            itemB = parseInt(itemB, 10);
                        }

                        // change logic depending on sort type
                        if ( _sort == 'asc' ){
                            if ( itemA < itemB ) return -1;
                            if ( itemA > itemB ) return 1;
                        } else if ( _sort == 'desc' ){
                            if ( itemA > itemB ) return -1;
                            if ( itemA < itemB ) return 1;
                        }

                        return 0;
                    });

                    // empty the existing list
                    $userList.empty();

                    // loop through array of users and add the newly sorted list items
                    var count = 0;
                    $.each(users, function(){
                        // make sure we don't insert hidden ones
                        if ( ! $(this).hasClass('hide-content') ){
                            $userList.append($(this));
                            count++;
                        }

                        // check if we've met the limit and limit is not set to 'all'
                        if ( _limit !== 'all' && ( count == parseInt(_limit, 10) ) ){
                            return false;
                        }
                    });
                }
            });
        }

        // classifications list search
        $('.js-classification-list-search').fsearch({
            list : '.js-classification-list .js-classification-entity'
        });

        // location map widget
        UI.loadMapWidget();

        $('.form-reset-link').on('click', function(e) {
            e.preventDefault();
            $(this).resetForm();
        });

        // Custom link to share a post on twitter
        $('.custom-twitter-share-link').each(function() {
            var url = $(this).attr('data-tweet-url') || '',
                text = $(this).attr('data-tweet-text') || '',
                hash = $(this).attr('data-tweet-hash') || '';

            $(this).attr('href', 'https://twitter.com/intent/tweet?url=' + encodeURI(url) + '&text=' + encodeURI(text) + '&hashtags=' + encodeURI(hash));
        });

        // Company Name Checkbox for donation forms
        if ($('#is-company-donation').length) {
            $('#is-company-donation').on('change', function() {
                var $nameFields = $('#name-fields'),
                    $companyInfo = $('#company-information'),
                    $employerInfo = $('#employer-information'),
                    $salutation = $('#salutation'),
                    target = $(this).attr('data-content-toggle'),
                    $targetFields = $(target).find('input');

                $targetFields.removeClass('validateEmpty');

                UI.clearErrors($targetFields);

                if($(this).is(':checked')){
                    $companyInfo.removeClass('hide-content').find('input').addClass('validateEmpty');
                    $nameFields.addClass('hide-content');
                    $salutation.addClass('hide-content');
                } else {
                    $nameFields.removeClass('hide-content').find('input').addClass('validateEmpty');
                    $salutation.removeClass('hide-content');
                    $companyInfo.addClass('hide-content');
                }
                $employerInfo.addClass('hide-content');
            });
        }

        // donation amount radio change to trigger all fake radios to update
        $(".js-donation-amount-option.hidden-offscreen[type=radio]")
            .on(
                "change",
                (e) => {
                    $(`[name="${e.target.name}"]`).trigger("radio-change");
                },
            ).on(
                "radio-change",
                (e) => {
                    const $radio = $(e.target);
                    const $visualRadio = $radio.closest("[role=radio]");
                    $visualRadio.attr("aria-checked", $radio.is(":checked"));
                },
            );

        // JS for delaying navigation dropdowns from hiding
        var $acctNavItem = $('.account-navigation .nav-item'),
            navTimeoutID;

        function delayNavHide( $element ) {
            navTimeoutID = window.setTimeout(function() {
                hideNavItem( $element );
            }, 400);
        }

        function clearNavDelay( $element ) {
            clearTimeout( navTimeoutID );
            hideNavItem( $element );
        }

        function hideNavItem( $element ) {
            $element.removeClass('hover-delay');
        }

        $acctNavItem.on('mouseenter', function() {
            var $element = $(this);

            // Flag this anchor as being hovered. mouseleave removes this flag
            $element.data('hovering', true);

            clearTimeout( navTimeoutID );

            // Make sure the element has a dropdown
            if ( $(this).find('.dropdown-container').length ) {
                // Wait before adding hover-delay to reveal the dropdown
                setTimeout(function() {
                    // If the element is still being hovered...
                    if ( $element.data('hovering') ) {
                        $element.addClass('hover-delay');

                        UI.bindClickOut('.nav-item', function() {
                            clearNavDelay( $element );
                        });
                    }
                }, 300);
            }
        });

        $acctNavItem.on('mouseleave', function() {
            var $element = $(this);

            // Clear flag so dropdown doesn't appear after moving the cursor
            $element.data('hovering', false);

            setTimeout(function(){
                // If no form fields are focused, close the dropdown
                if ( ! $element.find('.form-field').is(':focus') ) {
                    delayNavHide( $element );
                } else {
                    // If focused, watch for blur and when nothing is focused anymore, start the hover-delay
                    $element.find('.form-field').on('blur', function() {
                        setTimeout(function() {
                            if ( ! $element.find('.form-field').is(':focus') ) {
                                hideNavItem( $element );
                            }
                        }, 300);
                    });
                }
            }, 100);
        });

        // Show the profile complete message once
        if ( $('.profile-complete-message').length ) {
            var formID = $('#form-id').val(),
                registrantID = $('#registrant-id').val(),
                webStorageSuffix = '_' + formID + '_' + registrantID,
                messageStatus = WebStorage.get('walkthrough_completed_msg_status' + webStorageSuffix);

            if ( !messageStatus ) {
                $('.wt-messages-container').addClass('has-message').find('.profile-complete-message').removeClass('hide-content');
                WebStorage.set('walkthrough_completed_msg_status' + webStorageSuffix, true);
                setTimeout(function() {
                    $('.profile-complete-message').fadeOut(300, function() {
                        $(this).closest('.wt-messages-container').removeClass('has-message');
                    });
                }, 10000);
            }
        }

        // add offset to the Message object
        Message.offset = 60;
    };

    Interface.prototype.loadMapWidget = function(){
        $('.js-load-map-image').each(function(){
            var source = $(this).attr('data-source'),
                locations = [],
                gmapKey = '&key=AIzaSyCFX-ORTneJ2eAgkjIMwTkZpZd_2eqrcm4',
                map = 'https://maps.googleapis.com/maps/api/staticmap?size=640x400&scale=2&maptype=roadmap',
                $map = $('<img class="map-image js-map-image hide-content" />'),
                $locations = $(source).find('.js-map-location');

            // make sure we've got locations to render
            if ( $locations.length ) {
                $locations.each(function(){
                    locations.push({
                        name : $(this).attr('data-name'),
                        address : $(this).attr('data-address')
                    });
                });

                $.each(locations, function(i, v){
                    map += '&markers=color:blue|label:' + ( i + 1 );
                    map += '|' + encodeURIComponent(v.address);
                    map += gmapKey;
                });

                // remove any existing maps, just in case
                $(this).find('.js-map-image').remove();

                // add our new map
                $(this).append($map.attr('src', map));
                $(this).find('.js-map-image').delay(500).fadeIn(300, function(){
                    $(this).css('display', 'block');
                    $(this).parent().removeClass('is-loading ui-loading-background');
                });
            // else, hide our container
            } else {
                $(this).closest('.location-map-widget').addClass('hide-content');
            }
        });
    };

    $d.ready(function(){
        UI.init();
    });
})(jQuery);
